import Loader from 'react-ts-loaders';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/reducers/reducer';
import css from './createModuleWindow.module.scss';
import HiddenBlock from './HiddenBlock';
import MainBlock from './MainBlock';
import Button, { buttonsTypes } from '../../../../ui/button/button';
import useCatchEnterClick from '../../../../../hooks/useCatchEnterClick';
import { notificationSuccess } from '../../../../Notifications/callNotifcation';
import { useAppDispatch } from '../../../../../shared/libs/redux';
import Utils from '../../../../../shared/libs/Editor/utils/impl/Utils';
import { fileAPI } from '../../../../../entities/file/api/api';
import {
	setCreateModuleWindowPreview,
	setCreateModuleWindowPreviewId,
} from '../../../../../entities/module/private-template-module/model/slice';

interface ICreateModuleWindowProps {
	onCreateModule: (
		name: string,
		description: string,
	) => void,
    isModalActive: boolean,
	choicedCategoryId: string[],
	choicedLegalEntityId: string[],
	onAddChoicedTag: (id: string) => void,
	onRemoveChoicedTag: (id: string) => void,
	setChoicedCategoryId: (value: string[]) => void
	onRemoveChoicedLegalEntity: (id: string) => void,
	onAddChoicedLegalEntity: (id: string) => void,
	choicedTagsIds: string[],
}

const CreateModuleWindow: React.FC<ICreateModuleWindowProps> = ({
	isModalActive,
	choicedTagsIds,
	onRemoveChoicedLegalEntity,
	onAddChoicedTag,
	choicedCategoryId,
	onAddChoicedLegalEntity,
	setChoicedCategoryId,
	onRemoveChoicedTag,
	choicedLegalEntityId,
	onCreateModule,
}: ICreateModuleWindowProps) => {
	const dispatch = useAppDispatch();
	const preview = useSelector((state: RootState) => state.moduleWindow.createTemplateWindowPreview);
	const previewId = useSelector((state: RootState) => state.moduleWindow.createTemplateWindowPreviewId);

	const [imageUrl, setImageUrl] = useState<string | null>(null);
	const [nameInputValue, setNameInputValue] = useState('');
	const [descriptionValue, setDescriptionValue] = useState('');
	const [showMore, setShowMore] = useState(false);
	const [isBtnActive, setIsBtnActive] = useState(false);
	// Состояние загрузки изображения
	const [isImageLoading, setIsImageLoading] = useState(true);

	const [uploadPreview] = fileAPI.useSavePreviewMutation();

	const savePreview = async () => {
		if (!preview) return;

		try {
			const response = await uploadPreview({ name: '', bytes: preview }).unwrap();
			dispatch(setCreateModuleWindowPreviewId(response.id));
		} catch (error) {
			console.error('Ошибка при загрузке превью', error);
		}
	};

	const onCreate = () => {
		onCreateModule(nameInputValue, descriptionValue);
		notificationSuccess('Модуль успешно создан');
	};

	useEffect(() => {
		if (preview) {
			savePreview();
		}
	}, [preview]);

	useEffect(() => {
		if (previewId) {
			setImageUrl(`${Utils.Backend.getSystemImageURI(previewId)}?t=${new Date().getTime()}`);
		}
	}, [previewId]);

	useEffect(() => {
		if (!isModalActive) {
			setNameInputValue('');
			setDescriptionValue('');
			setShowMore(false);
			dispatch(setCreateModuleWindowPreview(''));
			setImageUrl('');
		}
	}, [isModalActive]);

	useEffect(() => {
		if (!nameInputValue || !choicedCategoryId?.length) {
			setIsBtnActive(false);
		} else {
			setIsBtnActive(true);
		}
	}, [nameInputValue, choicedCategoryId?.length]);

	useCatchEnterClick(onCreate, isBtnActive);

	// Обработчик для события загрузки изображения
	const handleImageLoad = () => {
		setIsImageLoading(false);
	};

	const handleImageError = () => {
		setIsImageLoading(false);
	};

	return (
		<div className={css.createTemplateWrapper}>
			{/* Лоадер, если изображение еще загружается */}
			{isImageLoading && <Loader className={css.loader} type="ring" color="#8e9db0" size={148} />}

			{preview
				&& (
					<img
						src={imageUrl ?? ''}
						alt="Base64"
						className={css.preview}
						onLoad={handleImageLoad}
						onError={handleImageError}
						// Скрываем изображение, пока оно не загружено
						style={{ display: isImageLoading ? 'none' : 'block' }}
					/>
				)}
			<div className={css.wrapper}>
				<div className={css.content}>
					<div className={css.title}>
						Создать модуль
					</div>
					<MainBlock
						nameInputValue={nameInputValue}
						showMore={showMore}
						setShowMore={setShowMore}
						choicedTagId={choicedTagsIds}
						choicedCategoryId={choicedCategoryId}
						setNameInputValue={setNameInputValue}
						onAddChoicedTag={onAddChoicedTag}
						onRemoveChoicedTag={onRemoveChoicedTag}
						setChoicedCategoryId={setChoicedCategoryId}
					/>
					{
						showMore && (
							<HiddenBlock
								descriptionValue={descriptionValue}
								setDescriptionValue={setDescriptionValue}
								choicedLegalEntityId={choicedLegalEntityId}
								onAddChoicedLegalEntity={onAddChoicedLegalEntity}
								onRemoveChoicedLegalEntity={onRemoveChoicedLegalEntity}
							/>
						)
					}
					<Button
						text="Создать модуль"
						onClick={onCreate}
						buttonType={buttonsTypes.BRIGHT}
						cssClass={css.btn}
						inActive={isBtnActive}
					/>
				</div>
			</div>
		</div>
	);
};

export default CreateModuleWindow;
